module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10035.9d709ff6.jpg";